module.exports = __webpack_public_path__ + "img/nav-pondmother.afb1f7d6.svg";